import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgNonDemand = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12.25 3.55998H7.75C7.6125 3.55998 7.5 3.67198 7.5 3.80887V5.05332H12.5V3.80887C12.5 3.67198 12.3875 3.55998 12.25 3.55998ZM6 5.05332V3.80887C6 2.84754 6.78438 2.06665 7.75 2.06665H12.25C13.2156 2.06665 14 2.84754 14 3.80887V5.05332H16C17.1031 5.05332 18 5.94621 18 7.04443V15.0089C18 16.1071 17.1031 17 16 17H4C2.89688 17 2 16.1071 2 15.0089V7.04443C2 5.94621 2.89688 5.05332 4 5.05332H6ZM13.3379 7.99616C13.1475 7.8057 12.8382 7.8057 12.6477 7.99616L10.0667 10.5757L7.48714 7.99616C7.29669 7.8057 6.98739 7.8057 6.79694 7.99616C6.60648 8.18661 6.60648 8.49439 6.79694 8.68484L9.37646 11.2659L6.79541 13.8454C6.60496 14.0359 6.60496 14.3452 6.79541 14.5356C6.98587 14.7261 7.29517 14.7261 7.48562 14.5356L10.0667 11.9561L12.6462 14.5371C12.8366 14.7276 13.1459 14.7276 13.3364 14.5371C13.5269 14.3467 13.5269 14.0374 13.3364 13.8469L10.7569 11.2659L13.3379 8.68637C13.5284 8.49591 13.5284 8.18661 13.3379 7.99616Z",
		fillRule: "evenodd",
		clipRule: "evenodd",
		fill: "#0D2976"
	})
});
export default SvgNonDemand;
